// Phone and WhatsApp Configuration
export const PHONE_NUMBER = '8597310624';
export const PHONE_NUMBER_FORMATTED = '+91 8597310624';
export const PHONE_NUMBER_DISPLAY = '+91 8597 310 624';

export const getPhoneLink = () => {
  return `tel:+91${PHONE_NUMBER}`;
};

export const getWhatsAppLink = (message = '') => {
  const defaultMessage = message || 'Hi! I am interested in your properties. Please provide more information.';
  
  // Use the simple wa.me format that always works
  return `https://wa.me/91${PHONE_NUMBER}?text=${encodeURIComponent(defaultMessage)}`;
};

// Helper function to open WhatsApp (for use in onClick handlers)
export const openWhatsApp = (message = '') => {
  const link = getWhatsAppLink(message);
  // Try to open in new window
  const newWindow = window.open(link, '_blank', 'noopener,noreferrer');
  
  // If blocked, navigate in same tab
  if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
    window.location.href = link;
  }
};

